import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import { useNavigate, useParams } from "react-router";
import { useAppSelector } from "../../../../redux";
import "./StatusMessage.scss";

const StatusMessage: React.FC<{}> = () => {
  const { status } = useAppSelector((state) => state.notes);
  const navigate = useNavigate();
  const { partnerID } = useParams();
  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="engagement-status-message-container">
      {status.addFormSalesNoteLoading ? (
        <Loader variant={LoaderSizes.large} />
      ) : status.addFormSalesNoteStatus ? (
        <>
          <Iconography
            icon="circleCheck"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Success}
          />
          <div className="message">Form successfully submitted</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() => navigate(`/hid-admin/dashboard/partner-organizations/${partnerID}/notes`)}
          />
        </>
      ) : (
        <>
          <Iconography
            icon="circleXmark"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Error}
          />
          <div className="message">{status.addFormSalesNoteMessage || "Something went wrong"}</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() => navigate(`/hid-admin/dashboard/partner-organizations/${partnerID}/notes`)}
          />
        </>
      )}
    </div>
  );
};

export default StatusMessage;
